import React from 'react';
import Money from '../../../../../Money';
import cn from 'classnames';
import { useTheme } from '../../../../../theme';
export const PriceItem = ({ name, price, isMinus, className }) => {
    const { PriceItem: css } = useTheme('PriceDetails');
    const priceWithoutMinus = Math.abs(price.amount);
    const showSing = isMinus && priceWithoutMinus > 0;
    return (React.createElement("div", { className: cn(css.root, className) },
        React.createElement("div", { className: css.title }, name),
        React.createElement("div", null,
            !!showSing && React.createElement("span", null, "-"),
            React.createElement(Money, { money: Object.assign(Object.assign({}, price), { amount: priceWithoutMinus }) }))));
};
export default PriceItem;
